__turbopack_context__.v({
  "headerLink": "_4WBPXG_headerLink",
  "headerLinks": "_4WBPXG_headerLinks",
  "headerLogo": "_4WBPXG_headerLogo",
  "hideOnNarrow": "_4WBPXG_hideOnNarrow",
  "inner": "_4WBPXG_inner",
  "isSubscribed": "_4WBPXG_isSubscribed",
  "notificationIcon": "_4WBPXG_notificationIcon",
  "root": "_4WBPXG_root",
});
